import { Stack, Text } from '@mantine/core'
import { modals } from '@mantine/modals'

import { LiveModuleBanner } from '@/components/LiveModuleBanner'

export function confirmLiveModuleAction(opts: { body: string; confirmLabel?: string }): Promise<boolean> {
  return new Promise(resolve => {
    modals.openConfirmModal({
      centered: true,
      withCloseButton: false,
      children: (
        <Stack gap="md">
          <LiveModuleBanner />
          <Text size="sm">{opts.body}</Text>
        </Stack>
      ),
      labels: { confirm: opts.confirmLabel ?? 'Continue', cancel: 'Cancel' },
      groupProps: { mt: 'xl' },
      onConfirm: () => resolve(true),
      onCancel: () => resolve(false),
      onClose: () => resolve(false),
    })
  })
}
